import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Warehouse, StockedItem } from './models/Warehouse';
import { Fertilizer } from './models/Fertilizer';
import { Phytochemical } from './models/Phytochemical';
import { Seed } from './models/Seed';
import { Product } from './models/Product';
import { Equipment, Implement, Machinery, EquipmentResume, Implant, Settings } from './models/Equipment';
import { Building } from './models/Building';
import { Team, TeamSubject } from './models/Team';
import { Plot } from './models/Plot';
import { Combination } from './models/Combination';
import { IOTService } from './models/IOTService';
import { GeocodingResult } from './models/GeoCoding';
import { TraceabilityGenericNode } from "./models/Traceability";
import { Water } from "./models/Water";
import { Fuel } from "./models/Fuel";
import { Electricity } from "./models/Electricity";
import { Staff } from "./models/Staff";

export default class AssetsVuexModule extends AbacoVuexModule {

    @State() curWarehouse!: Warehouse | null;
    @State() curStockedItem!: StockedItem | null;

    @State() curFertilizer!: Fertilizer | null;
    @State() curPhytochemical!: Phytochemical | null;
    @State() curSeed!: Seed | null;
    @State() curProduct!: Product | null;
    @State() curWater!: Water | null;
    @State() curFuel!: Fuel | null;
    @State() curElectricity!: Electricity | null;
    @State() curEquipment!: Equipment | null;
    @State() curEquipmentResume!: EquipmentResume | null;
    @State() curImplement!: Implement | null;
    @State() curImplant!: Implant | null;
    @State() curMachinery!: Machinery | null;
    @State() equipmentMapZoomToEquipment!: Equipment | null;
    @State() buildingMapZoomToBuilding!: Building | null;
    @State() curPlot!: Plot | null;
    @State() curBuilding!: Building | null;
    @State() newBuilding!: Building | null;
    @State() curCombination!: Combination | null;
    @State() curIOTService!: IOTService | null;
    @State() curTeam!: Team | null;
    @State() curTeamSubject!: TeamSubject | null;
    @State() curStaff!: Staff | null;
    @State() mapSearchPosition!: GeocodingResult | null;

    @State() warehouseAuth!: boolean | null;
    @State() warehouseViewAuth!: boolean | null;
    @State() fertilizerAuth!: boolean | null;
    @State() fertilizerViewAuth!: boolean | null;
    @State() fertilizerSuperAuth!: boolean | null;
    @State() phytochemicalAuth!: boolean | null;
    @State() phytochemicalViewAuth!: boolean | null;
    @State() seedAuth!: boolean | null;
    @State() seedViewAuth!: boolean | null;
    @State() productAuth!: boolean | null;
    @State() productViewAuth!: boolean | null;
    @State() waterAuth!: boolean | null;
    @State() waterViewAuth!: boolean | null;
    @State() fuelAuth!: boolean | null;
    @State() fuelViewAuth!: boolean | null;
    @State() electricityAuth!: boolean | null;
    @State() electricityViewAuth!: boolean | null;
    @State() traceabilityAuth!: boolean | null;

    @State() curTraceabilityNode!: TraceabilityGenericNode | null;

    @State() canViewCost!: boolean;
    @State() canEditCost!: boolean;

    @State() settings!: Settings;
}

